import type { User } from "./api";

export type Role = User["role"];

/**
 * ป้ายบทบาทภาษาลาว — ยกคำจาก mockup (`mockup.html` บรรทัด 821-825, 996-1005)
 *
 * `admin` คือชื่อเดิมของ `super_admin` ก่อน ADR-0016 ยังโผล่มาได้จาก token/แถวเก่า
 * จึงต้องมีป้ายให้ด้วย ไม่งั้นจอโชว์ค่าดิบ
 */
export const ROLE_LABEL_LO: Record<Role, string> = {
  citizen: "ປະຊາຊົນ",
  officer: "ຕາແສງ/ນາຍບ້ານ",
  district_finance: "ການເງິນເມືອງ",
  province_oversight: "ການເງິນແຂວງ",
  super_admin: "ຜູ້ບໍລິຫານລະບົບ",
  admin: "ຜູ້ບໍລິຫານລະບົບ",
  // ADR-0030: ນາຍບ້ານ ใช้แอปมือถือ ไม่เข้าคอนโซล แต่โผล่ในรายชื่อบัญชีที่ ຫົວໜ້າຕາແສງ จัดการ
  village_head: "ນາຍບ້ານ",
};

/** รวม `admin` เก่าเข้ากับ `super_admin` — ใช้ทุกที่ที่เทียบบทบาท */
export function canonicalRole(role: Role): Exclude<Role, "admin"> {
  return role === "admin" ? "super_admin" : role;
}

/** บทบาทที่ทำงานบน web-admin ได้ (ประชาชนใช้แอปมือถือ) */
export function isConsoleRole(role: Role): boolean {
  const r = canonicalRole(role);
  return r !== "citizen" && r !== "village_head";
}

export function roleBadgeClass(role: Role): string {
  switch (canonicalRole(role)) {
    case "super_admin":
      return "status-badge status-badge--info";
    case "province_oversight":
    case "district_finance":
      return "status-badge status-badge--pending";
    case "officer":
      return "status-badge status-badge--success";
    default:
      return "status-badge";
  }
}
